"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6878],{

/***/ 66878:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_EventCard__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8851);
/* harmony import */ var react_content_loader__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(24561);




var HomeEvents = function(param) {
    var data = param.data, loading = param.loading;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "usage-container py-md-3 px-md-5 py-5 px-2",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "row g-0",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "col pt-md-5",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h2", {
                                    className: "usage-title text-center",
                                    children: [
                                        "Everyday is a",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "color",
                                            children: " D-day  "
                                        }),
                                        "at  ",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "color",
                                            children: "KonfHub"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "sub-text text-center mx-auto",
                                    children: "No more dull days! Check out our exciting event line-up and register for upcoming events"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "row",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "col-12 text-center",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "d-flex flex-wrap featured-cards mt-4 pt-2 justify-content-center align-items-center",
                                    children: loading ? [
                                        "",
                                        "",
                                        ""
                                    ].map(function() {
                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_content_loader__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
                                                    viewBox: "0 0 300 350",
                                                    height: 350,
                                                    width: 300,
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                                                            x: "0",
                                                            y: "0",
                                                            rx: "5",
                                                            ry: "5",
                                                            width: "300",
                                                            height: "170"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                                                            x: "0",
                                                            y: "187",
                                                            rx: "4",
                                                            ry: "4",
                                                            width: "300",
                                                            height: "20"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                                                            x: "0",
                                                            y: "217",
                                                            rx: "4",
                                                            ry: "4",
                                                            width: "270",
                                                            height: "20"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                                                            x: "0",
                                                            y: "247",
                                                            rx: "4",
                                                            ry: "4",
                                                            width: "240",
                                                            height: "20"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                                                            x: "0",
                                                            y: "277",
                                                            rx: "4",
                                                            ry: "4",
                                                            width: "100",
                                                            height: "20"
                                                        })
                                                    ]
                                                })
                                            })
                                        });
                                    }) : data.length > 0 ? data.slice(0, 4).map(function(event, idx) {
                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_EventCard__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                            id: idx,
                                            poster_url: event.event_poster_url,
                                            category: event.category,
                                            name: event.event_name,
                                            logo_url: event.organiser_img,
                                            startDate: event.event_start_timestamp,
                                            endDate: event.event_end_timestamp,
                                            venue: event.venue,
                                            is_free: event.is_free,
                                            modeType: event.is_virtual,
                                            city: event.city,
                                            users: event.expected_participants,
                                            event_url: event.event_url,
                                            loading: loading
                                        });
                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "mt-5 mb-5 pb-5",
                                        children: "There are no featured events at the moment"
                                    })
                                })
                            }),
                            data.length > 4 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "d-flex justify-content-center",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    href: "/events",
                                    target: "_blank",
                                    rel: "noreferrer",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                        className: "btn btn-header mb-lg-2 mt-4 btn-styles ms-0",
                                        children: "Explore"
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("style", {
                children: "\n        .usage-container {\n            background: #f6f9fc;\n        }\n\n        .usage-container .usage-title {\n            color: #572148;\n            font-weight: 800;\n            font-size: 50px;\n            font-family: \"Nunito\";\n        }\n        .color{\n            color: #fb5850;\n        }\n        .featured-cards{\n          gap: 40px;\n        }\n        .conference_card {\n          height: 315px !important;\n          width: 290px;\n          border-radius: 6px;\n          background-color: white;\n          overflow: hidden;\n          cursor: pointer;\n          position: relative;\n      }\n        .sub-text{\n            font-family: 'Nunito';\n            font-style: normal;\n            font-weight: 500;\n            font-size: 20px;\n            text-align: center;\n            color: #4F4F4F;\n        }\n        .btn-styles{\n          height: 35px;\n          display: flex;\n          align-items: center;\n        }\n\n        .featured-cards{\n          flex-direction: row !important;\n        }\n        .card-img-top-hidden{\n          height: 200px;\n          background: rgb(134, 142, 150);\n        }\n\n        @media only screen and (min-width: 480px) and (max-width: 768px) {\n            .usage-container .usage-title {\n                font-size: 35px;\n            }\n        }\n\n        @media only screen and (min-width: 480px) and (max-width: 992px) {\n            .featured-cards{\n              flex-direction: column !important;\n            }\n        }\n\n\n\n        @media only screen and (max-width: 480px) {\n            .usage-container .usage-title {\n                font-size: 35px;\n            }\n            .featured-cards{\n              flex-direction: column !important;\n            }\n        }\n    "
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (HomeEvents);


/***/ })

}]);